import { render, staticRenderFns } from "./studentAttendance.vue?vue&type=template&id=71a03336&"
import script from "./studentAttendance.vue?vue&type=script&lang=js&"
export * from "./studentAttendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports